// extracted by mini-css-extract-plugin
export default {"background":"styles_background__x+2BN","image":"styles_image__eGMtv","container":"styles_container__xQg10","title":"styles_title__-n-+l"};